<template>
  <div>
    <v-date-picker
      class="date-picker"
      :min="this.dateMin()"
      :max="this.dateMax()"
      :locale="this.user.config.language"
      first-day-of-week="1"
      reactive
      :disabled="this.user.loading"
      v-model="date"
      full-width
      :allowed-dates="(val) => this.datesAllowed.indexOf(val) !== -1"
      @click:date="dateClicked"
      :picker-date.sync="date"
      :events="markEvents"
      :day-format="dayformat"
    />
    <div>
      <LoadingBar :loading="loadingMonth" />
      <div>
        <span class="rental-desc"></span>
        <small>{{ $t('pageDateTime.optionsDatesHasRental') }}</small>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import LoadingBar from '@/components/LoadingBar.vue';
import $axios from '../settings/axios.js';
import localizationTexts from '@/localization/texts.json';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'DatePicker',
  components: {
    LoadingBar
  },
  mounted() {
    this.$store.dispatch('user/initCheckToken').then(() => {
      this.getDates();
      if (this.user.config.parameters.parameters.enablerental) {
        this.getRentalDates();
      }
    });
  },
  data() {
    return {
      date: '',
      datesAllowed: [],
      setFirstDateActive: true,
      loadedMonths: [],
      loadingMonth: false,
      rentalReturned: false
    };
  },
  methods: {
    dateClicked(payload) {
      this.dateChange(payload);
    },
    markEvents(date) {
      if(!this.rentalReturned) {
        return null;
      }
      let rentalDates = this.user.lists.rentaldates;
      if (!rentalDates)  return false;
      let index = this.getIndexForEarliestAvailableDate() ;
      index = index > -1 ? index: 0;
      const mapping =  rentalDates.slice(index).find(x=>x.date == date);
      if(!mapping || !mapping.hasrental) return false;
      return ['#0000ff9c']; 
    },
    dayformat(date) {
      let day = date.substring(8, 10);
      if (day.startsWith('0')) {
        day = date.substring(9, 10);
      }
      return day;
    },
    dateChange(payload) {
      this.$emit('childToParent', payload);
    },
    getDates() {
      if (this.user.lists.dates.length == 0) {
        this.$store.dispatch('user/initLoading', true);
        var calendarinterval = this.user.config.parameters.parameters.calendarinterval || 3;
        this.getDate(calendarinterval);
      } else {
        this.datesAllowed = this.user.lists.dates;
        let index = this.getIndexForEarliestAvailableDate();
        this.date = this.user.lists.dates[index];
        this.dateChange(this.date);
      }
    },
    getRentalDates() {
      let minDate = this.dateMin();
      let maxDate = this.dateMax();
      if(!minDate) {
        minDate = new Date();
        minDate = minDate.toISOString().split('T')[0];
      }
      if(!maxDate) {
        let thisDate = new Date();
        maxDate = new Date(thisDate.setMonth(thisDate.getMonth()+1));
        maxDate = maxDate.toISOString().split('T')[0];
      }

      let payload = {
        endpoint: this.user.config.parameters.api + '/maintenance/dates/rental',
        params: {
          token: this.user.token,
          traceid: this.user.guid,
          rooftopid: this.user.selectedRooftopid,
          culture: this.user.config.parameters.parameters.culture,
          jobcodes: this.user.selectedservices.map(selectedservice => selectedservice.jobcode),
          totalserviceduration: this.user.selectedservices.map(service => service.jobtime).reduce((sum, duration) => sum + duration),
          makecode: this.user.car.makecode,
          modelcode: this.user.car.modelcode,
          variantcode: this.user.car.variantcode,
          today: minDate,
          calendarinterval: this.user.config.parameters.parameters.calendarinterval
        }
      };

      $axios.post(payload.endpoint, JSON.stringify(payload.params)).then(response => {
          response.data.forEach(element => (element.date = element.date.slice(0, 10)));
          this.$store.dispatch('user/initListRentalDates', response.data);
          this.rentalReturned = true;
        },
        error => {
          const errorPayload = {
            modal: true,
            send: false,
            traceid: this.user.guid,
            error: {
              message: 'GET_RENTAL_DATES',
              jsondata: JSON.stringify(error)
            }
          };
          this.dispatch('errors/setDataRentalDates', errorPayload);
        }
      );
    },
    getDate(calendarinterval) {
      const servicesTimeHoursToMinutes = this.user.servicesTime.hours * 60;
      const calculatedServiceTime = servicesTimeHoursToMinutes + this.user.servicesTime.minutes;
      const servicesTime = calculatedServiceTime == 0 ? 10 : calculatedServiceTime;
      let payload = {
        endpoint: this.user.config.parameters.api + '/maintenance/dates',
        params: {
          token: this.user.token,
          traceid: this.user.guid,
          rooftopid: this.user.selectedRooftopid,
          culture: this.user.config.parameters.parameters.culture,
          registrationplate: this.user.registrationplate,
          services: this.user.selectedservices,
          makecode: this.user.car.makecode,
          modelcode: this.user.car.modelcode,
          variantcode: this.user.car.variantcode,
          monthstartdate: this.dateInitial(),
          totalserviceduration: servicesTime,
          calendarinterval: calendarinterval,
          test: this.user.config.parameters.parameters.test
        }
      };

      this.$store
        .dispatch('user/initListDates', payload)
        .then(async () => {
          this.datesAllowed = this.user.lists.dates;
          this.$store.dispatch('user/initLoading', false);
          if (this.user.lists.dates.length == 0) {
            alert(`${localizationTexts[this.user.config.language].errors.GetAvailableDatesError.title}`);
            this.$store.dispatch('user/initLoading', false);

          } else {
            this.$store.dispatch('errors/resetErrors', 'date');
            let index = this.getIndexForEarliestAvailableDate();
            this.date = this.user.lists.dates[index];
            this.dateChange(this.date);

            this.loadingMonth = true;
            await this.$store.dispatch('user/handleOptionsDatesMappings', this.date.slice(0, 7));
            this.loadingMonth = false;
          }
        })
        .catch(() => {
          if (this.user.lists.dates.length == 0) {
            this.$store.dispatch('user/errorDate');
            this.$store.dispatch('user/initLoading', false);
          }
        });
    },
    formatDate(date) {
      return date.toISOString().slice(0, 10).toString();
    },
    dateInitial() {
      let today = new Date();
      today.setDate(today.getDate() + Math.floor(this.user.config.parameters.parameters.calendarbuffer));
      let initial = this.formatDate(today);
      return initial;
    },
    dateEnd(run) {
      return ((new Date(this.dateInitial()).getMonth() + run) % 12) + 1;
    },
    dateMin() {
      let index = this.getIndexForEarliestAvailableDate();
      let first = this.user.lists.dates[index];
      return first;
    },
    dateMax() {
      let last = this.user.lists.dates[this.user.lists.dates.length - 1];
      return last;
    },
    getIndexForEarliestAvailableDate() {
      let bufferDate = new Date();
      bufferDate.setDate(bufferDate.getDate() + this.user.config.parameters.parameters.calendarbuffer);
      bufferDate.setHours(0, 0, 0, 0);
      let index = 0;
      let firstDate = new Date(this.user.lists.dates[index]);
      firstDate.setHours(0, 0, 0, 0);
      while (index < this.user.lists.dates.length && firstDate < bufferDate) {
        firstDate = new Date(this.user.lists.dates[index]);
        firstDate.setHours(0, 0, 0, 0);
        index++;
      }
      index = Math.max(index - 1, 0);
      return index;
    },
    async loadMonth(month) {
      if (!this.loadedMonths.some((alreadyLoaded) => alreadyLoaded == month)) {
        this.loadedMonths.push(month);
        if (!this.user.lists.dates || this.user.lists.dates == 0) return;
        this.loadingMonth = true;
        await this.$store.dispatch('user/handleOptionsDatesMappings', month);
        this.loadingMonth = false;
      }
    }
  },
  computed: mapGetters(['user']),
  watch: {
    date(newVal, oldVal) {
      let newMonth = newVal.slice(5, 7);
      let oldMonth = oldVal.slice(5, 7);
      if (newMonth != oldMonth) {
        this.loadMonth(newVal);
      }
    }
  }
});
</script>

<style lang="scss">
.date-picker {
  .v-picker__body {
    border: #b0b0b0 solid 1px;
    border-radius: 0 0 10px 10px;
  }
}
</style>
<style scoped lang="scss">
.rental-desc {
  background-color: rgba(0, 0, 255, 0.6);
  border-color: rgba(0, 0, 255, 0.6);
  border-radius: 50%;
  display: inline-block;
  height: 8px;
  margin: 0 1px;
  width: 8px;
}
</style>

<i18n src="../localization/texts.json"></i18n>
